import create from 'zustand';

import {
  CreateReportExpenseFormData,
  CreateReportGrowthRatesFormData,
  CreateReportPropertyFormData,
  CreateReportPurchaseFormData,
  CreateReportRevenueFormData
} from '../models/reports/input';

export type Location = CreateReportPropertyFormData;
export type Purchase = CreateReportPurchaseFormData;
export type GrowthRates = CreateReportGrowthRatesFormData;
export type Revenue = CreateReportRevenueFormData;
export type Expenses = CreateReportExpenseFormData;

interface ReportStore {
  location: Location | undefined;
  purchase: Purchase | undefined;
  growthRates: GrowthRates | undefined;
  revenue: Revenue | undefined;
  expenses: Expenses | undefined;
  updateLocation: (location: Location) => void;
  getLocation: () => Location | undefined;
  updatePurchase: (purcahse: Purchase) => void;
  getPurchase: () => Purchase | undefined;
  updateGrowthRates: (growthRate: GrowthRates) => void;
  getGrowthRates: () => GrowthRates | undefined;
  updateRevenue: (revenue: Revenue) => void;
  getRevenue: () => Revenue | undefined;
  updateExpenses: (expenses: Expenses) => void;
  getExpenses: () => Expenses | undefined;
}

export const useReportStore = create<ReportStore>((set, get) => ({
  location: undefined,
  purchase: undefined,
  growthRates: undefined,
  revenue: undefined,
  expenses: undefined,
  updateLocation: (location: Location) => set(() => ({ location })),
  getLocation: () => get().location,
  updatePurchase: (purchase: Purchase) => set(() => ({ purchase })),
  getPurchase: () => get().purchase,
  updateGrowthRates: (growthRates: GrowthRates) => set(() => ({ growthRates })),
  getGrowthRates: () => get().growthRates,
  updateRevenue: (revenue: Revenue) => set(() => ({ revenue })),
  getRevenue: () => get().revenue,
  updateExpenses: (expenses: Expenses) => set(() => ({ expenses })),
  getExpenses: () => get().expenses
}));

export default useReportStore;
